module.exports = __webpack_public_path__ + "static/img/NG@2x.e4cd0bf3.jpg";